import { useEffect } from 'react';
import { useMutation } from 'urql';
import { logger } from '@rea-argonaut/observability';
import { saveRecentlyViewedPropertyMutation } from '../../graphql/SaveRecentlyViewedPropertyMutation';

export const useTrackRecentlyViewedProperty = ({
  isSignedIn,
  propertyId,
  lockeId,
}: {
  isSignedIn: boolean;
  propertyId: string;
  lockeId?: string;
}) => {
  const [_, saveRecentlyViewedProperty] = useMutation(saveRecentlyViewedPropertyMutation);

  useEffect(() => {
    const saveProperty = async () => {
      if (propertyId && isSignedIn) {
        await saveRecentlyViewedProperty({ propertyId });
      }
    };

    saveProperty().catch((error: Error) => {
      logger.error({
        error,
        description: `Failed to save recently viewed property with propertyId: ${propertyId} for lockeId: ${lockeId ?? 'unknown'}`,
      });
    });
  }, [propertyId, isSignedIn, saveRecentlyViewedProperty, lockeId]);
};
